module.exports = __webpack_public_path__ + "img/car_shina2_36.6109b4ad.jpg";